<template>
  <main role="main">
    <meta-title :title="metaTitle"></meta-title>
    <section class="section section-default section-text">
      <div class="container m-container-only-s">
        <LegalPolicy />
      </div>
    </section>
  </main>
</template>

<script>
import LegalPolicy from "@/components/LegalPolicy";

export default {
  name: "PrivacyPolicy",
  components: {
    LegalPolicy
  },
  title() {
    return this.$t("pages.privacy");
  }
};
</script>

<style scoped></style>
